import { Modal } from "@/components/elements/Modal";
import { Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

type TConfirmModalProps = {
  message: ReactNode;
  open: boolean;
  onClose: () => void;
  onOk: () => void;
  title?: string;
  labelOk?: string;
  labelClose?: string;
};

/**
 * Generic confirmation modal for various confirmation scenarios.
 * Uses "はい" / "いいえ" buttons by default.
 */
export const ConfirmModal: FC<TConfirmModalProps> = ({
  open,
  onClose,
  onOk,
  message,
  title = "確認",
  labelOk = "はい",
  labelClose = "いいえ",
}) => {
  return (
    <Modal isOpen={open} onClose={onClose} onOk={onOk} labelClose={labelClose} labelOk={labelOk} width={500} title={title}>
      <Stack mb={2}>
        <Typography component="div">{message}</Typography>
      </Stack>
    </Modal>
  );
};
